module.exports = __webpack_public_path__ + "fonts/subset-Averta-Bold.e7169f6.eot";